import { useCountryList } from 'hooks/countryList/useCountryList.hook';
import { ISelectValue } from 'interfaces/Data/SelectValue.interface';
import { IOptionGroup } from 'components/Modals/AddEditModal/ModalSection/fields/SelectField/SelectField.types';

type TOptionsKey = 'country' | 'addressCountry' | 'countryOfBirth' | string;

interface IUseGetCountrySelectOptionsReturn {
  getOptions: (propertyName: TOptionsKey) => ISelectValue[];
  countriesOptionGroups: IOptionGroup[];
}

export const useGetCountrySelectOptions =
  (): IUseGetCountrySelectOptionsReturn => {
    const { countriesList, countriesOptionGroups } = useCountryList();

    const getOptions = (propertyName: TOptionsKey): ISelectValue[] => {
      switch (propertyName) {
        case 'country':
        case 'addressCountry':
        case 'countryOfBirth':
          return countriesList;
        default:
          return [];
      }
    };

    return {
      getOptions,
      countriesOptionGroups,
    };
  };
